import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { DashboardPage } from '@/features/dashboard/components';

function DashboardRoute(): ReactNode {
  return (
    <AuthGuard>
      <DashboardPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/dashboard')({
  component: DashboardRoute,
});
